import { render } from "./SubNavigation.vue?vue&type=template&id=4372ccca"
import script from "./SubNavigation.vue?vue&type=script&lang=js"
export * from "./SubNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__